
import {
  getFactoryConstant,
  createFactoryTask,
  getFactoryDetail,
  getFactoryList,
  selectFactoryImage,
  uploadLocalSource,
  deleteSource,
} from '../services/api';

export default {
  namespace: 'image',

  state: {
    constants: {},
    listData: {
      totalCount: 1,
      list: [],
    },
    loading: false,
  },

  effects: {
    *deleteSource({ payload, callback }, { call, put }) {
      const response = yield call(deleteSource, payload);
      if (callback) {
        callback(response);
      }
    },
    *uploadLocalSource({ payload, callback }, { call, put }) {
      const response = yield call(uploadLocalSource, payload);
      if (callback) {
        callback(response);
      }
    },
    *getFactoryConstant({ payload, callback }, { call, put }) {
      const response = yield call(getFactoryConstant, payload);
      yield put({
        type: 'loadFactoryConstant',
        payload: response,
      });
    },
    *createFactoryTask({ payload, callback }, { call, put }) {
      const response = yield call(createFactoryTask, payload);
      if (callback) {
        callback(response);
      }
    },
    *getFactoryDetail({ payload, callback }, { call, put }) {
      const response = yield call(getFactoryDetail, payload);
      if (callback) {
        callback(response);
      }
    },
    *getFactoryList({ payload, callback }, { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      })
      const response = yield call(getFactoryList, payload);
      yield put({
        type: 'loadFactoryList',
        payload: response,
      })
      yield put({
        type: 'changeLoading',
        payload: false,
      })
    },
    *selectFactoryImage({ payload, callback }, { call, put }) {
      const response = yield call(selectFactoryImage, payload);
      if (callback) {
        callback(response);
      }
    },
  },

  reducers: {
    loadFactoryConstant(state, { payload }) {
      return {
        ...state,
        constants: payload,
      };
    },
    loadFactoryList(state, { payload }) {
      const listData = payload;
      return {
        ...state,
        listData,
      }
    },
    changeLoading(state, { payload }) {
      return {
        ...state,
        loading: payload,
      }
    },
  },
};
